import { render, staticRenderFns } from "./CreateResourceChapter.vue?vue&type=template&id=6398510b&scoped=true&"
import script from "./CreateResourceChapter.vue?vue&type=script&lang=ts&"
export * from "./CreateResourceChapter.vue?vue&type=script&lang=ts&"
import style0 from "./CreateResourceChapter.vue?vue&type=style&index=0&id=6398510b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6398510b",
  null
  
)

export default component.exports